const initState = {
  authError: "",
  uid: "",
  registered: false,
  user: null,
};
const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        uid: action.user.id,
        user: { ...action.user },
        authError: "",
      };
    case "UPDATE_USER_DEVICE_TOKEN":
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    case "LOGIN_FAIL":
      localStorage.clear();
      return {
        ...state,
        uid: "",
        authError: action.error.message,
      };
    case "LOGOUT_SUCCESS":
      return {
        ...state,
        authError: "",
        uid: "",
        registered: false,
        user: null,
      };
    case "UPDATE_CONTEST_STATUS":
      return {
        ...state,
        user: {
          ...state.user,
          showContests: action.payload,
        },
      };
    default:
      return {
        ...state,
      };
  }
};
export default authReducer;
